import { render } from "./AlbumModal.vue?vue&type=template&id=75277a31&scoped=true"
import script from "./AlbumModal.vue?vue&type=script&lang=js"
export * from "./AlbumModal.vue?vue&type=script&lang=js"

import "./AlbumModal.vue?vue&type=style&index=0&id=75277a31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75277a31"]])

export default __exports__